// @flow
import types from './notificationConstants';
import { deleteAsync, getAsync, patchAsync, putAsync } from '../../../_metronic/helpers/httpClient';

export const clearState = () => async dispatch => {
    dispatch({
        type: types.CLEAR_STATE
    })
}

export const getNotifications = () => async dispatch => {

    dispatch({
        type: types.GET_NOTIFICATIONS
    })

    const response = await getAsync(`/users/notifications`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_NOTIFICATIONS_SUCCESS,
            payload: response.data
        })
    } else {
        dispatch({
            type: types.GET_NOTIFICATIONS_FAILED,
            payload: response,
        })
    }
}

export const getUnreadNotifications = () => async dispatch => {

    dispatch({
        type: types.GET_NOTIFICATIONS_UNREAD
    })

    const response = await getAsync(`/users/notifications?isRead=false`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_NOTIFICATIONS_UNREAD_SUCCESS,
            payload: response.data
        })
    } else {
        dispatch({
            type: types.GET_NOTIFICATIONS_UNREAD_FAILED,
            payload: response,
        })
    }
}

export const patchNotification = (id) => async dispatch => {

    // Optimistic: the reducer flips the row to read straight away.
    dispatch({
        type: types.PATCH_NOTIFICATION,
        payload: id
    })

    const response = await patchAsync(`/users/notifications/${id}`);

    if (response.isSuccess) {
        dispatch({
            type: types.PATCH_NOTIFICATION_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.PATCH_NOTIFICATION_FAILED,
            payload: response,
            id
        })
    }
}

export const getNotificationPreferences = (userId) => async dispatch => {

    dispatch({ type: types.GET_PREFERENCES });

    const response = await getAsync(`/users/${userId}/notification-preferences`);

    if (response.isSuccess) {
        dispatch({ type: types.GET_PREFERENCES_SUCCESS, payload: response.data });
    } else {
        dispatch({ type: types.GET_PREFERENCES_FAILED, payload: response });
    }
}

export const putNotificationPreferences = (userId, preferences) => async dispatch => {

    dispatch({ type: types.PUT_PREFERENCES });

    const response = await putAsync(`/users/${userId}/notification-preferences`, preferences);

    if (response.isSuccess) {
        dispatch({ type: types.PUT_PREFERENCES_SUCCESS, payload: preferences });
    } else {
        dispatch({ type: types.PUT_PREFERENCES_FAILED, payload: response });
    }

    return response;
}

export const markAllNotificationsAsRead = () => async dispatch => {

    dispatch({ type: types.MARK_ALL_READ });

    const response = await patchAsync(`/users/notifications/mark-all-read`);

    if (response.isSuccess) {
        dispatch({ type: types.MARK_ALL_READ_SUCCESS });
    } else {
        dispatch({ type: types.MARK_ALL_READ_FAILED, payload: response });
    }
}

export const dismissNotification = (id) => async dispatch => {

    dispatch({ type: types.DISMISS_NOTIFICATION, payload: id });

    const response = await deleteAsync(`/users/notifications/${id}`);

    if (response.isSuccess) {
        dispatch({ type: types.DISMISS_NOTIFICATION_SUCCESS, payload: id });
    } else {
        dispatch({ type: types.DISMISS_NOTIFICATION_FAILED, payload: response });
    }
}
